<template>
  <CRow>
    <CCol>
      <CRow>
        <CCol sm="12" md="5">
          <b-form-group :label="$store.state.form.periode" label-for="periodeGaji" class="my-0">
            <Multiselect
              id="periodeGaji"
              v-model="filter.periode"
              :options="listPeriodeGaji"
              :multiple="false"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :placeholder="$store.state.form.placeholderPeriode"
              label="namaPeriode"
              track-by="id"
              @input="hitungTanggal()"
            ></Multiselect>
          </b-form-group>
        </CCol>

        <CCol sm="12" md="3">
          <b-form-group :label="$store.state.form.bulanTahun" label-for="bulanTahun" class="my-0">
            <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
          </b-form-group>
        </CCol>

        <CCol sm="12" md="2" class="mb-1">
          <div class="w-100 h-100 d-flex align-items-end">
            <b-button variant="danger" class="d-block w-100" v-c-tooltip.hover.click="$store.state.table.tooltipReset" @click="reset()">
              {{ $store.state.form.reset }}
            </b-button>
          </div>
        </CCol>

        <CCol sm="12" md="2" class="mb-1">
          <div class="w-100 h-100 d-flex align-items-end">
            <b-button variant="success" class="d-block w-100" v-c-tooltip.hover.click="$store.state.table.tooltipRekap" @click="rekap()">
              {{ button }}
            </b-button>
          </div>
        </CCol>

        <CCol sm="12">
          <small class="mx-2"> {{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ({{ filter.jmlHari }} hari) </small>
        </CCol>

        <CCol sm="12" class="mt-1 mb-2"><hr /></CCol>
      </CRow>

      <CRow v-if="ok">
        <CCol>
          <CRow>
            <CCol sm="12">
              <h4>
                <strong>{{ $store.state.form.judulTHP }}</strong>
              </h4>
              <hr />
            </CCol>
          </CRow>

          <b-alert dismissible fade :show="showing" :variant="variant">{{ msg }}</b-alert>

          <CRow>
            <CCol sm="12">
              <b-table-simple borderless small>
                <b-tbody>
                  <!-- Gaji Pokok -->
                  <b-tr>
                    <b-td style="width: 35%">{{ $store.state.form.gajiPokok }}</b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">{{ convert(dataTHP.proret) }}</b-td>
                  </b-tr>

                  <!-- Tunjangan -->
                  <b-tr v-for="(item, idx) in dataTHP.tunjangan" :key="item.poolTunjanganId">
                    <b-td v-if="idx == 0">{{ $store.state.form.tunjangan }}</b-td>
                    <b-td v-else></b-td>
                    <b-td></b-td>
                    <b-td>{{ item.namaTunjangan }}</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">{{ convert(item.nominalTunjangan) }}</b-td>
                  </b-tr>

                  <!-- Insentif -->
                  <b-tr v-for="(item, idx) in dataTHP.list_insentif" :key="item.id">
                    <b-td v-if="idx == 0">{{ $store.state.form.insentif }}</b-td>
                    <b-td v-else></b-td>
                    <b-td></b-td>
                    <b-td>{{ item.namaTunjanganTidakTetap }} ({{ item.jumlah }})</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">{{ convert(item.insentif) }}</b-td>
                  </b-tr>

                  <!-- Lembur -->
                  <b-tr>
                    <b-td>{{ $store.state.form.lembur }}</b-td>
                    <b-td></b-td>
                    <b-td>{{ dataTHP.totalLembur }} Jam</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">{{ convert(dataTHP.totalNominalLembur) }}</b-td>
                  </b-tr>

                  <!-- Komisi -->
                  <b-tr>
                    <b-td>{{ $store.state.form.komisi }}</b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">{{ convert(dataTHP.totalKomisi) }}</b-td>
                  </b-tr>

                  <!-- Potongan Asuransi -->
                  <b-tr v-for="(item, idx) in dataTHP.list_asuransi" :key="item.namaAsuransi">
                    <b-td v-if="idx == 0">{{ $store.state.form.potonganAsuransi }}</b-td>
                    <b-td v-else></b-td>
                    <b-td></b-td>
                    <b-td>{{ item.namaAsuransi }}</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">- {{ convert(item.potonganAsuransi) }}</b-td>
                  </b-tr>

                  <!-- Potongan Denda -->
                  <b-tr v-for="(item, idx) in dataTHP.list_denda" :key="item.namaDenda">
                    <b-td v-if="idx == 0">{{ $store.state.form.potonganDenda }}</b-td>
                    <b-td v-else></b-td>
                    <b-td></b-td>
                    <b-td>{{ item.namaDenda }} ({{ item.jumlah }})</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">- {{ convert(item.nominalDenda) }}</b-td>
                  </b-tr>

                  <!-- Potongan -->
                  <b-tr v-for="(item, idx) in dataTHP.list_potongan" :key="item.idx">
                    <b-td v-if="idx == 0">{{ $store.state.form.potongan }}</b-td>
                    <b-td v-else></b-td>
                    <b-td></b-td>
                    <b-td>{{ item.namaPotongan }} ({{ item.jumlah }})</b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right">- {{ convert(item.nominalPotongan) }}</b-td>
                  </b-tr>

                  <!-- Total THP -->
                  <b-tr>
                    <b-td class="font-weight-bold">{{ $store.state.form.totalTHP }}</b-td>
                    <b-td></b-td>
                    <b-td></b-td>
                    <b-td>: Rp. </b-td>
                    <b-td class="text-right font-weight-bold">
                      {{ convert(totalTHP) }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>
  </CRow>
</template>

<script>
export default {
  props: ["data", "change", "activeTab"],
  data() {
    return {
      listPeriodeGaji: [],
      thn: [],
      dataTHP: [],
      ok: false,
      variant: "",
      msg: "",
      links: "",
      showing: false,
      button: "Rekap Gaji",
      tunTetap: [],
      filter: {
        periode: null,
        bulanTahun: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: "0",
        dataKaryawanId: this.$route.query.dataKaryawanId,
      },
    };
  },
  computed: {
    periode_gajian() {
      let x = Number(this.$moment().format("DD"));
      return x >= 6 && x < 20;
    },
    totalTHP() {
      let vm = this;
      let x = vm.dataTHP;
      x.gaji = 0;
      x.totalPotongan = 0;
      x.totalTunjangan = 0;
      x.totalDenda = 0;
      x.totalInsentif = 0;
      x.totalAsuransi = 0;
      if (x.nominalGajiKaryawan) {
        x.gaji += Number(x.proret);
      }
      if (x.tunjangan) {
        x.tunjangan.forEach((ele) => {
          x.totalTunjangan += Number(ele.nominalTunjangan);
        });
      }
      if (x.list_insentif) {
        x.list_insentif.forEach((ele) => {
          x.totalInsentif += Number(ele.insentif);
        });
      }
      if (x.list_denda) {
        x.list_denda.forEach((ele) => {
          x.totalDenda += Number(ele.nominalDenda);
        });
      }
      if (x.list_asuransi) {
        x.list_asuransi.forEach((ele) => {
          x.totalAsuransi += Number(ele.potonganAsuransi);
        });
      }
      if (x.list_potongan) {
        x.potongan.forEach((ele) => {
          x.totalPotongan += Number(ele.nominalPotongan);
        });
      }
      x.takeHomePay = Math.floor(x.gaji + x.totalInsentif + x.totalNominalLembur + x.totalTunjangan + x.totalKomisi - x.totalPotongan - x.totalAsuransi - x.totalDenda);
      return x.takeHomePay;
    },
  },
  watch: {
    activeTab: async function (newVar) {
      if (newVar === 0) {
        await this.getPeriodeGaji();
        await this.reset();
      }
    },
  },
  async mounted() {
    await this.getPeriodeGaji();
    await this.reset();
  },
  methods: {
    rekap() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.filter.peridoAwal = vm.filter.tglAwal;
      vm.filter.peridoAkhir = vm.filter.tglAkhir;
      vm.filter.dataRekap = vm.dataTHP;
      vm.$axios
        .post("rekapGaji/register", vm.filter)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = this.$store.state.form.simpan;
            vm.busy = false;
            vm.variant = "success";
            vm.msg = "BERHASIL MENDAFTARKAN REKAP GAJI";
            vm.showing = true;
            setTimeout(() => {
              vm.showing = false;
            }, 3000);
          } else {
            vm.button = this.$store.state.form.simpan;
            vm.busy = false;
            vm.variant = "danger";
            vm.msg = res.data.message.toUpperCase();
            vm.showing = true;
            setTimeout(() => {
              vm.showing = false;
            }, 3000);
          }
        })
        .catch((err) => {
          vm.button = this.$store.state.form.simpan;
          vm.busy = false;
          vm.variant = "danger";
          vm.msg = err.message.toUpperCase();
          vm.showing = true;
          setTimeout(() => {
            vm.showing = false;
          }, 3000);
        });
    },
    async hitungTanggal() {
      const vm = this;
      if (!vm.filter.periode) vm.filter.periode = vm.listPeriodeGaji[0];
      const periode = vm.filter.periode;
      const monthYear = vm.$moment(vm.filter.bulanTahun).format("MM-YYYY");
      //set tanggal terakhir bulan
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");
      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;
      //set tanggal default
      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      //jika tanggal awal adalah bulan sebelumnya (awal - akhir = 30 - 10)
      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        //jika xtanggalAwal adalah tanggal terakhir bulan
        let awal = periode.xtanggalAwal;
        /*
          jika tanggal awal = -1 (tanggal terakhir bulan) atau
          jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal akhir dalam bulan)
        */
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        //jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal awal dalam bulan)
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }
      //jika tanggal akhir melebihi tanggal dalam bulan (bulan februari tetapi tanggal akhir = 30, maka tanggal akhir ikut 28 / tanggal akhir dalam bulan)
      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }
      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "Days") + 1;
      vm.getDatas();
    },
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    async getDatas() {
      let vm = this;
      vm.ok = false;
      // let THP = await vm.$axios.post('dataKaryawan/rekapTanggal', vm.filter);
      let THP = await vm.$axios.post(vm.filter.periode.isBpjs ? "dataKaryawan/rekapTanggalBpjs" : "dataKaryawan/rekapTanggalNonBpjs", vm.filter);
      // console.log(THP.data.data, "take home pay");
      if (THP.data.status == 200 && THP.data.data.length) {
        vm.dataTHP = THP.data.data[0];
        vm.dataTHP.totalLembur = 0;
        vm.dataTHP.totalNominalLembur = 0;
        vm.dataTHP.list_asuransi = [];
        vm.dataTHP.list_denda = [];
        vm.dataTHP.list_potongan = [];
        vm.dataTHP.list_insentif = [];
        let absensi = vm.dataTHP.absensi[0];
        // if (vm.dataTHP.lembur) {
        vm.dataTHP.lembur.forEach((ele) => {
          vm.dataTHP.totalNominalLembur += Number(ele.nominalLembur);
          vm.dataTHP.totalLembur += Number(ele.jumlahJamLembur);
        });
        // }
        if (absensi) {
          // Clock In / Out (selalu dihitung, tidak ada flag berlaku)
          vm.dataTHP.list_denda.push({
            namaDenda: "Clock In/ Out",
            jumlah: absensi.hanyaAbsenKeluar + absensi.hanyaAbsenMasuk,
            nominalDenda: vm.dataTHP.dendaAbsenTidakLengkap,
          });
          // Terlambat di atas 10 menit (hanya kalau berlaku)
          if (absensi.terlambatDiatas10berlaku) {
            vm.dataTHP.list_denda.push({
              namaDenda: "Terlambat >10 Menit",
              jumlah: absensi.terlambatDiatas10,
              nominalDenda: absensi.terlambatDiatas10Total,
            });
          }
          // Terlambat di atas 60 menit (hanya kalau berlaku)
          if (absensi.terlambatDiatas60berlaku) {
            vm.dataTHP.list_denda.push({
              namaDenda: "Terlambat >60 Menit",
              jumlah: absensi.terlambatDiatas60,
              nominalDenda: absensi.terlambatDiatas60Total,
            });
          }
          vm.dataTHP.list_potongan.push({ namaPotongan: "Cuti", jumlah: absensi.jumlahCuti, nominalPotongan: vm.dataTHP.potonganCuti });
          vm.dataTHP.list_potongan.push({ namaPotongan: "Sakit", jumlah: absensi.jumlahSakit, nominalPotongan: vm.dataTHP.potonganSakit });
          vm.dataTHP.list_potongan.push({ namaPotongan: "Alpha", jumlah: absensi.jumlahAlfa, nominalPotongan: vm.dataTHP.potonganAlpha });
          vm.dataTHP.list_potongan.push({ namaPotongan: "Ijin", jumlah: absensi.jumlahIjin, nominalPotongan: vm.dataTHP.potonganIjin });
          vm.dataTHP.list_potongan.push({ namaPotongan: "Day Off", jumlah: absensi.totalDayOff, nominalPotongan: vm.dataTHP.potonganDayOff });
        }
        if (vm.dataTHP.tunjanganTidakTetap) {
          vm.dataTHP.tunjanganTidakTetap.forEach((ele) => {
            if (absensi) {
              ele.insentif = ele.nominalTunjanganTidaktetap * absensi.totalJadwal;
              ele.jumlah = absensi.totalJadwal;
              vm.dataTHP.list_insentif.push(ele);
            }
          });
        }
        if (vm.dataTHP.potongan) {
          vm.dataTHP.potongan.forEach((ele) => {
            vm.dataTHP.list_potongan.push(ele);
            // console.log(ele.insentif);
          });
        }
        if (vm.dataTHP.asuransi) {
          vm.dataTHP.asuransi.forEach((ele) => {
            vm.dataTHP.list_asuransi.push({
              namaAsuransi: ele.namaAsuransi,
              potonganAsuransi: ele.potonganAsuransi,
            });
            vm.dataTHP.totalAsuransi += Number(ele.potonganAsuransi);
          });
        }
        if (vm.dataTHP.bpjsKetenagaKerjaan) {
          vm.dataTHP.list_asuransi.push({
            namaAsuransi: "BPJS Ketenagakerjaan",
            potonganAsuransi: vm.dataTHP.bpjsKetenagaKerjaan,
          });
        }
        if (vm.dataTHP.bpjsKesehatan) {
          vm.dataTHP.list_asuransi.push({
            namaAsuransi: "BPJS Kesehatan",
            potonganAsuransi: vm.dataTHP.bpjsKesehatan,
          });
        }
        if (vm.$moment(vm.filter.tglAkhir) > vm.$moment(vm.filter.tglAwal)) {
          vm.ok = true;
        }
      }
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      // console.log('listPeriodeGaji : ', listPeriodeGaji)
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})${x.isBpjs ? ", BPJS" : ""}`,
              };
            })
          : [];
    },
    reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      this.hitungTanggal();
    },
  },
};
</script>
